<div *ngIf="compact && viewMode && !loading" class="customer-record">
  <section>
    <h2>Service address</h2>
    <p>{{ addressText('serviceAddress') }}</p>
  </section>
  <section>
    <h2>Contact</h2>
    <dl>
      <dt>Name</dt><dd>{{ form.get('customerInfo.contact')?.value || 'Not recorded' }}</dd>
      <dt>Phone</dt>
      <dd>
        <a *ngIf="form.get('customerInfo.phone')?.value as phone; else noPhone" [href]="'tel:' + phone">{{ phone }}</a>
        <ng-template #noPhone>Not recorded</ng-template>
        <span *ngIf="form.get('customerInfo.ext')?.value as ext"> ext. {{ ext }}</span>
      </dd>
      <dt>Mobile</dt>
      <dd><a *ngIf="form.get('customerInfo.mobilePhone')?.value as mobile; else noMobile" [href]="'tel:' + mobile">{{ mobile }}</a><ng-template #noMobile>Not recorded</ng-template></dd>
      <dt>Email</dt>
      <dd><a *ngIf="form.get('customerInfo.email')?.value as email; else noEmail" [href]="'mailto:' + email">{{ email }}</a><ng-template #noEmail>Not recorded</ng-template></dd>
    </dl>
  </section>
  <section>
    <h2>Notes</h2>
    <p class="customer-record__notes">{{ form.get('customerInfo.notes')?.value || 'No notes yet.' }}</p>
  </section>
  <details>
    <summary>Account details</summary>
    <dl>
      <dt>Name</dt><dd>{{ form.get('customerInfo.name')?.value || 'Not recorded' }}</dd>
      <dt>Type</dt><dd>{{ customerTypeName }}</dd>
      <dt>Assigned to</dt><dd>{{ assignedTo }}</dd>
      <dt>Source</dt><dd>{{ form.get('customerInfo.source')?.value || 'Not recorded' }}</dd>
      <dt>Website</dt><dd>{{ form.get('customerInfo.website')?.value || 'Not recorded' }}</dd>
      <dt>Fax</dt><dd>{{ form.get('customerInfo.fax')?.value || 'Not recorded' }}</dd>
    </dl>
  </details>
  <details>
    <summary>Billing address</summary>
    <p>{{ sameAsService ? 'Same as service address' : addressText('billingAddress') }}</p>
  </details>
</div>
<div class="customer-form" [class.customer-form--view]="viewMode"
     [formGroup]="form" *ngIf="!loading && (!compact || !viewMode)">
  <section class="customer-form__section" formGroupName="customerInfo">
    <h2>Customer</h2>

    <div class="customer-form__row">
      <label for="customer-name">Name</label>
      <div>
        <input id="customer-name" class="br-form-control" formControlName="name" [placeholder]="viewMode ? '—' : ''" />
        <span class="customer-form__error" *ngIf="form.get('customerInfo.name')?.touched && form.get('customerInfo.name')?.invalid">Name is required.</span>
      </div>
    </div>
    <div class="customer-form__row">
      <label for="customer-type">Customer Type</label>
      <select id="customer-type" class="br-form-select" formControlName="customerTypeId">
        <option [ngValue]="null">{{ viewMode ? '—' : (customerTypesLoading ? 'Loading customer types...' : 'Select customer type') }}</option>
        <option *ngIf="!customerTypesLoading && customerTypes.length === 0" disabled>No customer types available</option>
        <option *ngFor="let type of customerTypes" [ngValue]="type.id">{{ type.name }}</option>
      </select>
    </div>
    <div class="customer-form__row">
      <label for="customer-source">Lead Source</label>
      <select id="customer-source" class="br-form-select" formControlName="source">
        <option [ngValue]="null">{{ viewMode ? '—' : (sourcesLoading ? 'Loading sources...' : 'Select source') }}</option>
        <option *ngIf="!sourcesLoading && sources.length === 0" disabled>No sources available</option>
        <option *ngFor="let source of sources" [ngValue]="source">{{ source }}</option>
      </select>
    </div>
    <div class="customer-form__row">
      <label for="customer-assignee">Assignee</label>
      <select id="customer-assignee" class="br-form-select" formControlName="assigneeUserId">
        <option [ngValue]="null">{{ viewMode ? '—' : (assigneesLoading ? 'Loading assignees...' : 'Unassigned') }}</option>
        <option *ngIf="!assigneesLoading && assignees.length === 0" disabled>No assignees available</option>
        <option *ngFor="let assignee of assignees" [ngValue]="assignee.id">{{ assigneeName(assignee) }}</option>
      </select>
    </div>
    <div class="customer-form__row"><label for="customer-phone">Phone</label><input id="customer-phone" class="br-form-control" formControlName="phone" [placeholder]="viewMode ? '—' : ''" /></div>
    <div class="customer-form__row"><label for="customer-ext">Extension</label><input id="customer-ext" class="br-form-control" formControlName="ext" [placeholder]="viewMode ? '—' : ''" /></div>
    <div class="customer-form__row"><label for="customer-mobile">Mobile</label><input id="customer-mobile" class="br-form-control" formControlName="mobilePhone" [placeholder]="viewMode ? '—' : ''" /></div>
    <div class="customer-form__row">
      <label for="customer-email">Email</label>
      <div>
        <input id="customer-email" class="br-form-control" type="email" formControlName="email" [placeholder]="viewMode ? '—' : ''" />
        <span class="customer-form__error" *ngIf="form.get('customerInfo.email')?.touched && form.get('customerInfo.email')?.hasError('email')">Enter a valid email address.</span>
      </div>
    </div>
    <div class="customer-form__row"><label for="customer-website">Website</label><input id="customer-website" class="br-form-control" formControlName="website" [placeholder]="viewMode ? '—' : ''" /></div>
    <div class="customer-form__row"><label for="customer-contact">Contact Person</label><input id="customer-contact" class="br-form-control" formControlName="contact" [placeholder]="viewMode ? '—' : ''" /></div>
    <div class="customer-form__row"><label for="customer-fax">Fax</label><input id="customer-fax" class="br-form-control" formControlName="fax" [placeholder]="viewMode ? '—' : ''" /></div>
    <div class="customer-form__row"><label for="customer-notes">Notes</label><textarea id="customer-notes" class="br-form-control" rows="3" formControlName="notes" [placeholder]="viewMode ? '—' : ''"></textarea></div>
  </section>

  <section class="customer-form__section" formGroupName="serviceAddress">
    <h2>Service Address</h2>
    <div class="customer-form__row"><label for="service-line1">Address Line 1</label><input id="service-line1" class="br-form-control" formControlName="line1" [placeholder]="viewMode ? '—' : ''" /></div>
    <div class="customer-form__row"><label for="service-line2">Address Line 2</label><input id="service-line2" class="br-form-control" formControlName="line2" [placeholder]="viewMode ? '—' : ''" /></div>
    <div class="customer-form__row"><label for="service-city">City</label><input id="service-city" class="br-form-control" formControlName="city" [placeholder]="viewMode ? '—' : ''" /></div>
    <div class="customer-form__row">
      <label for="service-state">State</label>
      <select id="service-state" class="br-form-select" formControlName="stateId">
        <option [ngValue]="null">{{ viewMode ? '—' : (statesLoading ? 'Loading states...' : 'Select state') }}</option>
        <option *ngIf="!statesLoading && states.length === 0" disabled>No states available</option>
        <option *ngFor="let state of states" [ngValue]="state.id">{{ state.code }} - {{ state.label }}</option>
      </select>
    </div>
    <div class="customer-form__row"><label for="service-zip">ZIP / Postal</label><input id="service-zip" class="br-form-control" formControlName="zip" [placeholder]="viewMode ? '—' : ''" /></div>
  </section>

  <section class="customer-form__section" formGroupName="billingAddress">
    <h2>Billing Address</h2>
    <div class="customer-form__row">
      <label for="billing-same">Use Service Address</label>
      <span *ngIf="viewMode" class="customer-form__readonly-value">
        {{ sameAsService ? 'Yes' : 'No' }}
      </span>
      <mat-checkbox *ngIf="!viewMode" id="billing-same"
                    formControlName="sameAsService">Same as service address</mat-checkbox>
    </div>
    <div class="customer-form__row"><label for="billing-line1">Address Line 1</label><input id="billing-line1" class="br-form-control" formControlName="line1" [placeholder]="viewMode ? '—' : ''" /></div>
    <div class="customer-form__row"><label for="billing-line2">Address Line 2</label><input id="billing-line2" class="br-form-control" formControlName="line2" [placeholder]="viewMode ? '—' : ''" /></div>
    <div class="customer-form__row"><label for="billing-city">City</label><input id="billing-city" class="br-form-control" formControlName="city" [placeholder]="viewMode ? '—' : ''" /></div>
    <div class="customer-form__row">
      <label for="billing-state">State</label>
      <select id="billing-state" class="br-form-select" formControlName="stateId">
        <option [ngValue]="null">{{ viewMode ? '—' : (statesLoading ? 'Loading states...' : 'Select state') }}</option>
        <option *ngIf="!statesLoading && states.length === 0" disabled>No states available</option>
        <option *ngFor="let state of states" [ngValue]="state.id">{{ state.code }} - {{ state.label }}</option>
      </select>
    </div>
    <div class="customer-form__row"><label for="billing-zip">ZIP / Postal</label><input id="billing-zip" class="br-form-control" formControlName="zip" [placeholder]="viewMode ? '—' : ''" /></div>
  </section>
</div>

<ng-container *ngIf="loading" [ngTemplateOutlet]="loadingState"></ng-container>
<ng-template #loadingState>
  <div class="customer-form__loading"><mat-spinner diameter="32"></mat-spinner></div>
</ng-template>
